import React, { useState } from 'react';

const CONTENT = {
    fr: {
        title: 'Politique de confidentialité — TOGALMA',
        updated: 'Dernière mise à jour : 15 septembre 2026',
        sections: [
            {
                h: '1. Qui sommes-nous',
                p: [
                    "TOGALMA est une application mobile de recettes de cuisine et de commande d'ingrédients, éditée par DJIBSON CONSULTING, dont le siège est situé Cité AMES II, ZAC Mbao, Dakar, Sénégal.",
                    'Contact : contact@dkr-consulting.com',
                ],
            },
            {
                h: '2. Les données que nous collectons',
                p: [
                    "Lorsque vous créez un compte : votre nom, votre numéro de téléphone, et votre adresse email si vous choisissez d'en fournir une. Votre mot de passe est enregistré sous forme chiffrée et n'est jamais lisible en clair.",
                    'Lorsque vous passez une commande : les produits et quantités commandés, le montant, le moyen de paiement choisi, ainsi que le nom et le numéro de téléphone de contact que vous indiquez pour la livraison.',
                    "Vos préférences d'affichage : langue et thème clair ou sombre, conservés uniquement sur votre appareil.",
                ],
            },
            {
                h: '3. Ce que nous ne collectons pas',
                p: [
                    "Nous ne collectons pas votre position géographique. Nous n'utilisons aucun outil de publicité ciblée, aucun traceur publicitaire et aucun outil d'analyse comportementale tiers. Nous ne vendons ni ne louons vos données à quiconque. L'application ne lit pas vos contacts et n'accède pas à votre appareil photo.",
                ],
            },
            {
                h: '4. Accès à vos photos',
                p: [
                    "L'application demande l'accès à votre photothèque uniquement dans son espace d'administration, réservé aux gestionnaires de la boutique, pour choisir l'image d'une bannière. Un utilisateur ordinaire n'est jamais sollicité pour cette autorisation, et aucune photo n'est lue sans action explicite de votre part.",
                ],
            },
            {
                h: '5. Paiements',
                p: [
                    "Les paiements sont traités par Wave et Orange Money. Vous êtes redirigé vers leur application ou leur page sécurisée pour valider le paiement. TOGALMA ne reçoit, ne traite ni ne conserve aucune donnée bancaire : ni numéro de carte, ni code, ni identifiant de compte de paiement. Nous conservons uniquement le montant, la date, le moyen de paiement et le statut de la transaction.",
                ],
            },
            {
                h: '6. Où sont hébergées vos données',
                p: [
                    "Vos données sont hébergées chez Supabase, notre prestataire d'infrastructure de base de données. Elles sont protégées par des accès restreints.",
                ],
            },
            {
                h: '7. Combien de temps nous les conservons',
                p: [
                    'Vos données de compte sont conservées tant que votre compte existe. Vos commandes sont conservées tant que votre compte existe. Lorsque vous supprimez votre compte, tout est effacé immédiatement.',
                ],
            },
            {
                h: '8. Supprimer votre compte',
                p: [
                    "Vous pouvez supprimer votre compte à tout moment, directement depuis l'application : onglet Profil, puis « Supprimer mon compte », en bas de l'écran. La suppression est immédiate et définitive. Votre compte et l'intégralité de vos commandes sont effacés. Aucune récupération n'est possible et nous ne conservons aucune copie.",
                    "Si vous ne parvenez pas à accéder à l'application, écrivez-nous à contact@dkr-consulting.com et nous procéderons à la suppression.",
                ],
            },
            {
                h: '9. Vos droits',
                p: [
                    "Vous pouvez à tout moment consulter, corriger ou supprimer vos données. La consultation et la correction se font depuis l'onglet Profil de l'application. La suppression se fait comme décrit ci-dessus. Pour toute autre demande, écrivez à contact@dkr-consulting.com ; nous répondons sous trente jours.",
                ],
            },
            {
                h: '10. Enfants',
                p: [
                    "TOGALMA n'est pas destinée aux enfants de moins de 13 ans et nous ne collectons pas sciemment leurs données.",
                ],
            },
            {
                h: '11. Modifications',
                p: [
                    'Toute modification de cette politique sera publiée sur cette page, avec mise à jour de la date en haut du document.',
                ],
            },
            {
                h: '12. Nous contacter',
                p: ['Pour toute question relative à vos données : contact@dkr-consulting.com'],
            },
        ],
    },
    en: {
        title: 'Privacy Policy — TOGALMA',
        updated: 'Last updated: September 15, 2026',
        sections: [
            {
                h: '1. Who we are',
                p: [
                    'TOGALMA is a mobile application for cooking recipes and ingredient ordering, published by DJIBSON CONSULTING, headquartered at Cité AMES II, ZAC Mbao, Dakar, Senegal.',
                    'Contact: contact@dkr-consulting.com',
                ],
            },
            {
                h: '2. The data we collect',
                p: [
                    'When you create an account: your name, your phone number, and your email address if you choose to provide one. Your password is stored in encrypted form and is never readable in plain text.',
                    'When you place an order: the products and quantities ordered, the amount, the chosen payment method, as well as the contact name and phone number you provide for delivery.',
                    'Your display preferences: language and light or dark theme, stored only on your device.',
                ],
            },
            {
                h: "3. What we don't collect",
                p: [
                    'We do not collect your geographic location. We do not use any targeted advertising tools, advertising trackers, or third-party behavioral analytics tools. We do not sell or rent your data to anyone. The application does not read your contacts and does not access your camera.',
                ],
            },
            {
                h: '4. Access to your photos',
                p: [
                    'The application requests access to your photo library only in its administration area, reserved for store managers, to choose a banner image. An ordinary user is never asked for this permission, and no photo is read without your explicit action.',
                ],
            },
            {
                h: '5. Payments',
                p: [
                    'Payments are processed by Wave and Orange Money. You are redirected to their application or secure page to validate the payment. TOGALMA does not receive, process, or store any banking data: no card number, no code, no payment account identifier. We only keep the amount, the date, the payment method, and the status of the transaction.',
                ],
            },
            {
                h: '6. Where your data is hosted',
                p: [
                    'Your data is hosted by Supabase, our database infrastructure provider. It is protected by restricted access.',
                ],
            },
            {
                h: '7. How long we keep it',
                p: [
                    'Your account data is kept as long as your account exists. Your orders are kept as long as your account exists. When you delete your account, everything is erased immediately.',
                ],
            },
            {
                h: '8. Deleting your account',
                p: [
                    'You can delete your account at any time, directly from the application: Profile tab, then "Delete my account", at the bottom of the screen. Deletion is immediate and final. Your account and all of your orders are erased. No recovery is possible and we do not keep any copy.',
                    'If you cannot access the application, write to us at contact@dkr-consulting.com and we will carry out the deletion.',
                ],
            },
            {
                h: '9. Your rights',
                p: [
                    'You can view, correct, or delete your data at any time. Viewing and correction are done from the Profile tab of the application. Deletion is done as described above. For any other request, write to contact@dkr-consulting.com; we respond within thirty days.',
                ],
            },
            {
                h: '10. Children',
                p: [
                    'TOGALMA is not intended for children under 13 years of age and we do not knowingly collect their data.',
                ],
            },
            {
                h: '11. Changes',
                p: [
                    'Any change to this policy will be published on this page, with the date at the top of the document updated.',
                ],
            },
            {
                h: '12. Contact us',
                p: ['For any question regarding your data: contact@dkr-consulting.com'],
            },
        ],
    },
};

export default function TogalmaPrivacy() {
    const [lang, setLang] = useState('fr');
    const c = CONTENT[lang];

    return (
        <main data-testid="togalma-privacy-page" className="min-h-screen pt-24 pb-20">
            <div className="max-w-3xl mx-auto px-6 md:px-8">
                {/* Language selector */}
                <div className="flex justify-end mb-6">
                    <div className="inline-flex rounded-full border border-white/10 overflow-hidden text-sm">
                        <button
                            onClick={() => setLang('fr')}
                            data-testid="privacy-lang-fr"
                            className={`px-4 py-1.5 transition-colors ${lang === 'fr' ? 'bg-blue-600 text-white' : 'text-slate-400 hover:text-white'}`}
                        >
                            FR
                        </button>
                        <button
                            onClick={() => setLang('en')}
                            data-testid="privacy-lang-en"
                            className={`px-4 py-1.5 transition-colors ${lang === 'en' ? 'bg-blue-600 text-white' : 'text-slate-400 hover:text-white'}`}
                        >
                            EN
                        </button>
                    </div>
                </div>

                <h1 className="text-3xl md:text-4xl font-bold text-white mb-2" data-testid="privacy-title">{c.title}</h1>
                <p className="text-sm text-slate-400 mb-10" data-testid="privacy-updated">{c.updated}</p>

                <div className="space-y-8">
                    {c.sections.map((s) => (
                        <section key={s.h}>
                            <h2 className="text-lg font-semibold text-white mb-3">{s.h}</h2>
                            {s.p.map((para, i) => (
                                <p key={i} className="text-slate-300 leading-relaxed mb-3 text-sm md:text-base">{para}</p>
                            ))}
                        </section>
                    ))}
                </div>
            </div>
        </main>
    );
}
